module.exports = __webpack_public_path__ + "static/img/tbg.f610b81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/tbg.jpg
// module id = cyXh
// module chunks = 0